import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  FetchProjectsRequestPayload,
  FetchProjectsSuccessPayload,
  MainStateInterface,
  ProjectInterface,
  CreateProjectRequestPayload
} from "./interfaces";

const initialState: MainStateInterface = {
  isLoading: false,
  projects: [],
  project: null,
  projectsTotal: 0
};

export const mainSlice = createSlice({
  name: "main",
  initialState,
  reducers: {
    fetchProjectsRequest: (
      state,
      _: PayloadAction<FetchProjectsRequestPayload>
    ) => {
      state.isLoading = true;
    },
    fetchProjectsSuccess: (
      state,
      action: PayloadAction<FetchProjectsSuccessPayload>
    ) => {
      const { payload } = action;
      state.isLoading = false;
      state.projects = payload.projects ?? [];
      state.projectsTotal = payload.total;
    },
    fetchProjectsError: (state) => {
      state.isLoading = false;
    },

    createProjectRequest: (
      state,
      _: PayloadAction<CreateProjectRequestPayload>
    ) => {
      state.isLoading = true;
    },
    createProjectSuccess: (state, action: PayloadAction<ProjectInterface>) => {
      const { payload } = action;
      state.isLoading = false;
      state.projects = [payload, ...state.projects];
    },
    createProjectError: (state) => {
      state.isLoading = false;
    },

    renameProjectRequest: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    renameProjectSuccess: (state, action: PayloadAction<ProjectInterface>) => {
      const { payload } = action;

      state.isLoading = false;
      state.projects = state.projects.map((project) =>
        project.id === payload.id ? payload : project
      );
    },
    renameProjectError: (state) => {
      state.isLoading = false;
    },

    deleteProjectRequest: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    deleteProjectSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.projects = state.projects.filter(
        (project) => project.id.toString() !== payload.message.toString()
      );
    },
    deleteProjectError: (state) => {
      state.isLoading = false;
    }
  }
});

export const { actions, reducer } = mainSlice;
